<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-date-picker
        v-model="date"
        @change="changeDate"
        style="margin-right: 15px"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :editable="false"
      >
      </el-date-picker>
      <el-select
        v-model="tableParams.subjectId"
        clearable
        placeholder="请选择主体"

        filterable
      >
        <el-option
          v-for="item in subjectList"
          :label="item.subjectName"
          :value="item.subjectId"
        ></el-option>
      </el-select>
      <el-select
        v-model="tableParams.isConfirm"
        clearable
        placeholder="请选择是否确认订单"

        filterable
      >
        <el-option label="是" :value="0" :key="0"></el-option>
        <el-option label="否" :value="1" :key="1"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.invoiceType"
        clearable
        placeholder="请选择发票类型"

        filterable
      >
        <el-option label="信息服务费" :value="0" :key="0"></el-option>
        <el-option label="广告发布费" :value="1" :key="1"></el-option>
        <el-option label="技术服务费" :value="2" :key="2"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.collectStatus"
        clearable
        placeholder="请选择结算状态"

        filterable
      >
        <el-option label="已结算" :value="0" :key="0"></el-option>
        <el-option label="部分结算" :value="1" :key="1"></el-option>
        <el-option label="未结算" :value="2" :key="2"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.isInvoicing"
        clearable
        placeholder="请选择是否开票"

        filterable
      >
        <el-option label="是" :value="0" :key="0"></el-option>
        <el-option label="否" :value="1" :key="1"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.invoicingSubject"
        placeholder="请选择发票主体"
        clearable
        filterable
      >
        <el-option
          v-for="item in invoicingList"
          :label="item.subjectName"
          :value="item.subjectId"
          :key="item.subjectId"
        ></el-option>
      </el-select>
      <el-input
        v-model="tableParams.formerName"
        placeholder="请输入广告主主体曾用名"
        clearable
      ></el-input>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel(
              '/subjectCollect/down/subject/collect',
              '主体报表',
              tableParams
            )
          "
          type="warning"
          size="small"
          >下载
        </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        :summary-method="tableSummary"
        show-summary
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span v-if="v.field === 'isConfirm'">
              {{ scope.row.isConfirm === 0 ? "是" : "否" }}
            </span>
            <span v-else-if="v.field === 'isInvoicing'">
              {{ scope.row.isInvoicing === 0 ? "是" : "否" }}
            </span>
            <span v-else-if="v.field === 'collectStatus'">
              {{
                scope.row.collectStatus === 0
                  ? "已结算"
                  : scope.row.collectStatus === 1
                  ? "部分结算"
                  : "未结算"
              }}
            </span>
            <span v-else-if="v.field === 'invoiceType'">
              {{
                scope.row.invoiceType === 0
                  ? "信息服务费"
                  : scope.row.invoiceType === 1
                  ? "广告发布费"
                  : "技术服务费"
              }}
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
              >编辑</el-button
            >
            <el-button
              @click="updateFormerName(scope.row)"
              type="warning"
              size="mini"
              >曾用名</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60,pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      title="编辑"
      @close="cancel"
    >
      <el-form
        :model="updateForm"
        label-width="auto"
        :rules="updateRules"
        ref="updateForm"
      >
        <el-form-item label="是否确认订单">
          <el-radio
            v-model="updateForm.isConfirm"
            :disabled="disabledConfirm"
            :label="0"
            >是</el-radio
          >
          <el-radio
            v-model="updateForm.isConfirm"
            :disabled="disabledConfirm"
            :label="1"
            >否</el-radio
          >
        </el-form-item>

        <el-form-item label="已结算收入" prop="alreadyIncome">
          <el-input
            v-model="updateForm.alreadyIncome"
            :disabled="disabledConfirm"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开票">
          <el-radio
            v-model="updateForm.isInvoicing"
            :disabled="disabledConfirm"
            :label="0"
            >是</el-radio
          >
          <el-radio
            v-model="updateForm.isInvoicing"
            :disabled="disabledConfirm"
            :label="1"
            >否</el-radio
          >
        </el-form-item>
        <el-form-item label="发票金额">
          <el-input
            v-model="updateForm.invoicingIncome"
            :disabled="disabledConfirm"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票主体">
          <el-select
            v-model="updateForm.invoicingSubject"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in invoicingList"
              :label="item.subjectName"
              :value="item.subjectId"
              :key="item.subjectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-radio-group
            v-model="updateForm.collectStatus"
            :disabled="disabledConfirm"
          >
            <el-radio :label="0">已结算</el-radio>
            <el-radio :label="1">部分结算</el-radio>
            <el-radio :label="2">未结算</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票类型">
          <el-radio-group
            v-model="updateForm.invoiceType"
            :disabled="disabledConfirm"
          >
            <el-radio :label="0">信息服务费</el-radio>
            <el-radio :label="1">广告发布费</el-radio>
            <el-radio :label="2">技术服务费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="回款日期">
          <el-date-picker
            style="width: 100%"
            v-model="updateForm.paymentDate"
            format="YYYYMMDD"
            value-format="YYYYMMDD"
            :disabled="disabledConfirm"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="updateForm.remark" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="text-align: right">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      v-model="dialogStatus2"
      :close-on-click-modal="false"
      title="修改曾用名"
      @close="cancel2"
      width="500px"
    >
      <span>曾用名：</span>
      <el-input
        v-model="formerList.formerName"
        placeholder="请输入曾用名"
        style="width: 200px"
      ></el-input>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="cancel2">取消</el-button>
        <el-button type="primary" @click="submit2">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import { downExcelMixin } from '@/mixins/downExcel'
import { updateSubjectCollect, getInvoicing, updateFormerName } from '@/api/manage/subject/channelSubject'
import { formatDate, SIMPLE_MONTH_PATTERN } from '@/util/format'
import { getMasterSubjectInfo } from '@/api/report/dsp'

export default {
  name: 'channelSubject',
  components: {
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    const validateIncome = (rule, value, callback) => {
      // 已结算金额可以大于待结算金额，业务有这种情况存在
      if (value > this.updateForm.invoicingIncome) {
        callback()
      }
      // value 是int，invoicingIncome 是字符，用 == 判断
      if (value == this.updateForm.invoicingIncome) {
        callback()
      }
      if (value == 0) {
        callback()
      }
      if (value < this.updateForm.invoicingIncome && this.updateForm.alreadyIncome > 0) {
        callback()
      }
    }
    return {
      columns: [
        { field: 'timeHour', title: '月份' },
        { field: 'subjectName', title: '主体名称' },
        { field: 'formerName', title: '广告主主体曾用名' },
        { field: 'uniShowSmt', title: '展示量' },
        { field: 'uniClkSmt', title: '点击量' },
        { field: 'collectStatus', title: '结算状态' },
        { field: 'isConfirm', title: '是否确认订单' },
        { field: 'isInvoicing', title: '是否开票' },
        { field: 'invoiceType', title: '发票类型' },
        { field: 'invoicingIncome', title: '发票金额' },
        { field: 'invoicingSubjectName', title: '发票主体' },
        { field: 'paymentDate', title: '回款日期' },
        { field: 'awaitIncome', title: '待结收入' },
        { field: 'alreadyIncome', title: '已结算收入' },
        { field: 'remark', title: '备注' }
      ],
      hides: [
        'uniWinSmt', 'bidRate', 'cpcPrice', 'effectiveResSmt'
      ],
      date: [new Date(), new Date()],
      dialogStatus: false,
      updateForm: {},
      disabledConfirm: false,
      subjectList: [],
      invoicingList: [],
      dialogStatus2: false,
      formerList: {},
      updateRules: {
        alreadyIncome: [
          { validator: validateIncome, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.date[0].setMonth(new Date().getMonth(), 0)
    this.date[1].setMonth(new Date().getMonth(), 0)
    this.changeDate(this.date)
  },
  mounted () {
    this.$nextTick(() => {
      this.getSubjectInfo()
      this.getInvoicing()
      this.init()
    })
  },
  methods: {
    getSubjectInfo () {
      getMasterSubjectInfo().then(res => {
        this.subjectList = res.data
      })
    },
    update (row) {
      this.dialogStatus = true
      row.isConfirm === 0 ? this.disabledConfirm = true : this.disabledConfirm = false
      this.updateForm = Object.assign({}, row)
      if (this.updateForm.invoicingSubject === 0) this.updateForm.invoicingSubject = undefined
      if (this.updateForm.paymentDate) {
        this.updateForm.paymentDate = row.paymentDate.toString()
      }
    },
    submit () {
      this.$refs.updateForm.validate((valid) => {

        if (valid) {
          if (this.updateForm.isConfirm === 0 && this.disabledConfirm === false) {
            this.$confirm('请确认部分结算或已结算的金额，一旦确认则不可修改。并将自动确认订单！', '确认订单').then(() => {
              this.updateSubjectCollect()
            })
              .catch(() => {})
          } else {
            this.updateSubjectCollect()
          }
        }
      })
    },
    getInvoicing () {
      getInvoicing().then(res => {
        this.invoicingList = res.data
      })
    },
    updateSubjectCollect () {
      this.updateForm.paymentDate = Number(this.updateForm.paymentDate)
      updateSubjectCollect(this.updateForm).then(res => {
        this.$message.success('编辑成功')
        this.dialogStatus = false
        this.init()
      })
    },
    cancel () {
      this.$refs.updateForm.resetFields()
      this.dialogStatus = false
      this.updateForm = {}
    },
    beforeInit () {
      this.tableUrl = '/subjectCollect/get/subject/collect'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
    },
    changeDate (date) {
      this.tableParams.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.tableParams.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    tableSummary (row) {
      const arr = ['invoicingIncome', 'awaitIncome', 'alreadyIncome']
      const { data } = row
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0).toFixed(2) : '-'
        }
      }
      return out
    },
    sizeChange (e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    toQuery () {
      this.init()
    },
    updateFormerName (row) {
      this.dialogStatus2 = true
      this.formerList.formerName = row.formerName
      this.formerList.reportId = row.reportId
    },
    cancel2 () {
      this.dialogStatus2 = false
      this.formerList = Object.assign({}, {})
    },
    submit2 () {
      updateFormerName(this.formerList)
        .then(res => {
          this.$message.success('修改曾用名成功')
          this.dialogStatus2 = false
          this.init()
        })
    }
  }
}
</script>

  <style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

::v-deep.el-table__body-wrapper {
  order: 0;
}
</style>
